<template>
  <div class="do-header">
    <div class="do-nav do-nav__left">
      <router-link :to="'/plan/' + schoolId"
                   class="nav-item"
                   active-class="nav-item--selected">
        <span class="icon-calendar2"></span>
        Vagtplan
      </router-link>
      <router-link :to="'/show'" class="nav-item"
                   active-class="nav-item--selected">
        <span class="icon-clock"></span>
        Arbejdstider
      </router-link>
    </div>
    <ul class="do-nav nav__right">
      <li></li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    }
  }
}
</script>

<style scoped>
.do-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  background: #fff;
  height: 55px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

.do-nav {
  display: flex;
}

.nav-item {
  display: flex;
  gap: 1rem;
  flex: 1;
  align-items: center;
  cursor: pointer;
  padding: 0 20px;
  margin: 0;
  align-items: center;
  font-size: 11px;
  text-transform: uppercase;
  color: rgba(62, 68, 80, 0.7);
  font-weight: bold;
  border-right: 1px solid #e6e8ef;
  position: relative;
}

.nav-item.nav-item--selected {
  border-top: 2px solid #468AD7;
  background: #F6F7F8;
  color: #3e4450;
}

</style>



// WEBPACK FOOTER //
// DoHeader.vue?0314aeb8